import React, { Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { API_TIKTOK_AUTH } from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

class Index extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    var restUrl =
      window.location.href.split('?').length > 1
        ? window.location.href.split('?')[1]
        : window.location.href.split('?')[0];        
    AxiosAPI({
      method: 'post',
      url: `${API_TIKTOK_AUTH}/code/${params.get('state')}?group_id=${getGroupID()}&property_id=${this.props.propertyId}&code=${params.get('code')}`,
      data: { code: params.get('code'), redirectUrl: `https://${localStorage.getItem('host_name_url')}/${process.env.REACT_APP_TIKTOK_REDIRECT_URL}` },
    }).then((res) => {
      window.location.href = `/app/pages/integration/channels`;
    });    

  }

  render() {
    return <Fragment></Fragment>;
  }
}
const mapStateToProps = ({ settings, service }) => {
  const { propertyId, tiktokId } = settings;
  const { featuresUrl } = service;
  return {
    propertyId,
    tiktokId,
    featuresUrl
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
